import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { isArray } from 'util';
import { environment } from '../../../environments/environment';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { IModelloStampa, ModelliStampaService } from '../../services/modelli-stampa.service';
import { Utenteservice } from '../../services/utente.service';
import { NicaAnagraficaComponent, ToolbarButton } from '../nica-anagrafica/nica-anagrafica.component';

@Component({
  selector: 'app-show-rentri',
  templateUrl: './show-rentri.component.html',
  styleUrls: ['./show-rentri.component.css'],
  //encapsulation: ViewEncapsulation.Emulated
})
export class ShowRentriComponent implements OnInit, AfterViewInit {
  myFilter: string = '';
  sediRentri
  registriRentri: any[] = [];
  primaryListData: any[] = [];
  filteredSecondaryListData: any[] = [];
  @ViewChild('uEsportazioni', { static: false }) griglia: NicaAnagraficaComponent;
  selectedIdSito: any;
  selectedIdRedistro: any;
  dallaData: any;
  allaData: any;
  pulsantiOpzionali:ToolbarButton;
  isDateBoxDisabled: boolean = true
  isExecuteDisabled: boolean = true
  jsonResult: any;
  xmlString: string;
  windowHeight: any;
  idRenClicked: any;
  altezza: number;
  minDate: string;
  maxDate: string;
  help="RegistroCronologicoDigitale.html";
  stpDisable: boolean = true;

  PulsantiSuNavBar: ToolbarButton[] = [
    {
      location: 'after',
      options: {
        disabled: this.isExecuteDisabled,
        class: 'classToolBar',
        icon: 'assets/icons/icons8-stampa-40.png',
        title: 'Stampa Registro',
        text: '',
        index: 1,
        id: "idStampa",
      }
    }, 
    {
      location: 'after',
      options: {
        disabled: this.isExecuteDisabled,
        class: 'classToolBar',
        icon: 'assets/icons/icons8-xml-48.png',
        title: 'Download Pacchetto',
        text: '',
        index: 2,
        id: "idDownload"
      }
    }

  ]

  /*
      this.appService.GetApi("RenEsportazioni/GetElencoMovimentiPerStampa"+query).then((result:any)=>{
        this.loader.hide();
        this.modelliStampaService.generaPDF(result,66,'preview');
      }).catch(e=>{
        this.loader.hide();
      })
  //anteprimaAllegato
  
  */
  //uEsportazioni
  constructor(public appService: Apiservice,
    private modelliStampaService: ModelliStampaService,
    public loader: NgxSpinnerService,
    private userservice: Utenteservice,
    public userComponentService: ComponentService,
  ) {
    this.myFilter = "?codiceFiscaleAzienda=" + this.userservice.InfoUtenteConnesso.codiceFiscale

    this.appService.GetApi("RenEsportazioni/GetElencoSedi" + this.myFilter).then(result => {
      console.log("AA ", result)
      this.sediRentri = result;
      this.sediRentri.forEach((item, index) => {
        this.appService.GetApi("RenEsportazioni/GetElencoRegistriByIdSedeRentri?idSedeRentri=" + item.id).then(result => {
          this.registriRentri.push(result)
        })
      });
    })

    this.appService.GetApi("RenEsportazioni/GetElencoRegistriByIdSedeRentri?idSedeRentri=OP2404RYW000051").then(result => {
      console.log("BB ", result)
    })

  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      const parentElement = document.querySelector('.altezza').parentElement;
      // Legge l'altezza del parent
      const parentHeight = parentElement.offsetHeight;
      this.windowHeight = parentHeight - 380;
      this.altezza = parentHeight
      //this.griglia.gridHeight=20 
      console.log('Altezza del parent:', parentHeight);
    }, 500);


  }
  onCallHelp(){
    var w = 1064;
    var h = 800;
    const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
    const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    this.loader.show();
    setTimeout(() => {
      let data = {      
        url: environment.BASE_URL_HELP + this.help,
        enableShow: true
      }

      this.userComponentService.enableHelpNDoc(data);
      this.loader.hide();
    }, 1000);

  }
  ngOnInit(): void {

    this.modelliStampaService.ricaricaModelliPubblici();
    //this.windowHeight = this.renderer.selectRootElement('window').innerHeight;
    //this.windowHeight =1070;// window.innerHeight;

    this.myFilter = "?codiceFiscaleAzienda=" + this.userservice.InfoUtenteConnesso.codiceFiscale
    this.loadPrimaryList();

  }

  loadPrimaryList(): void {
    this.appService.GetApi('RenEsportazioni/GetElencoSedi' + this.myFilter).then((data: any) => {
      this.primaryListData = data;
      this.primaryListData = [
        { id: 0, descrizione: 'Tutte' }, // Valore "speciale"
        ...this.primaryListData,
      ];
    });
  }

  onAllaDataChanged(event: any) {

    console.log("alla Data Cambiata ", event)
    console.log(this.allaData)
    if (this.dallaData) {

    }
    this.onApplyFilter();

  }

  onDallaDataChanged(event: any) {
    console.log("dalla Data Cambiata ", event)
    console.log(this.dallaData)
    this.onApplyFilter();
  }
  //isExecuteDisabled
  checkIsExecuteDisabled() {
    return (this.dallaData && this.allaData) ? false : true
  }

  checkIsDateBoxDisabled() {
    var x = (this.selectedIdSito && this.selectedIdRedistro) ? false : true;
    return (this.selectedIdSito > '0' && this.selectedIdRedistro > '') ? false : true
  }

  // Chiamata dinamica per la lista secondaria in base alla selezione della lista principale
  onPrimarySelectionChanged(event: any): void {

    const selectedId = event.component.option('value');
    if (selectedId) {
      this.loadSecondaryList(selectedId);
      /*this.filteredSecondaryListData = [
        { id: 0, descrizione: 'Tutti' }, // Valore "speciale"
        ...this.filteredSecondaryListData,
      ];*/
    } else {
      this.filteredSecondaryListData = [];
    }
    this.selectedIdSito = selectedId
    // ID Sede RENTRI

    /*if(this.selectedIdSito && this.selectedIdSito>'0'){
     
      this.griglia.griglia.instance.filter(['idsitorentri', 'contains', this.selectedIdSito]);
    }
     else{    
     this.griglia.griglia.instance.filter(null)     
   }*/
    this.selectedIdRedistro = 0
    this.isDateBoxDisabled = this.checkIsDateBoxDisabled()
    this.isExecuteDisabled = this.checkIsExecuteDisabled();
    this.griglia.disableCustomButton('idStampa', this.isExecuteDisabled)
    this.griglia.disableCustomButton('idDownload', this.isExecuteDisabled)

    //this.onApplyFilter();
    this.dallaData = null;
    this.allaData = null;
  }
  onSecondarySelectionChanged(event: any): void {
    const selectedId = event.component.option('value');
    this.selectedIdRedistro = selectedId
    this.dallaData = null;
    this.allaData = null;
    this.onApplyFilter();
  }
  loadSecondaryList(primaryId: number): void {
    this.appService.GetApi(`RenEsportazioni/GetElencoRegistriByIdSedeRentri?idSedeRentri=${primaryId}`).then((data: any) => {
      this.filteredSecondaryListData = data;
      this.filteredSecondaryListData = [
        { id: 0, descrizione: 'Tutti' }, // Valore "speciale"
        ...this.filteredSecondaryListData,
      ];
    });
  }
  onApplyFilter() {
    this.isDateBoxDisabled = this.checkIsDateBoxDisabled()
    this.isExecuteDisabled = this.checkIsExecuteDisabled();
    this.griglia.disableCustomButton('idDownload', this.isExecuteDisabled)
    this.griglia.disableCustomButton('idStampa', this.isExecuteDisabled)
    // alert(this.selectedIdSito);

    let ciccio = [];
    let vv = []

    //return;
    if (this.selectedIdRedistro && this.selectedIdRedistro > '0') {
      //this.griglia.griglia.instance.filter([['idregistrorentri', '=', this.selectedIdRedistro],'and',['idsitorentri', '=', this.selectedIdSito]]);
      let rr = ['idregistrorentri', '=', this.selectedIdRedistro]
      if (ciccio.length > 0) ciccio.push("and")
      ciccio.push(rr);

    }
    else {
      if (this.selectedIdSito > '0') {
        let rr = ['idsitorentri', '=', this.selectedIdSito]
        if (ciccio.length > 0) ciccio.push("and")
        ciccio.push(rr);

      }
    }
    // controllo Date
    if (!this.isDateBoxDisabled) {
      if (this.dallaData) {
        let rr = [];
        rr = ['datainizio', '>=', this.dallaData]
        if (ciccio.length > 0) ciccio.push("and")
        ciccio.push(rr);
      }
      if (this.allaData) {
        let rr = [];
        rr = ['datafine', '<=', this.allaData]
        if (ciccio.length > 0) ciccio.push("and")
        ciccio.push(rr);
      }
    }
    // rr=['codiceFiscale', '=', '05669600636']
    //if(ciccio.length>0) ciccio.push("and")
    //  ciccio.push(rr);
    if (ciccio.length == 0) {
      this.griglia.griglia.instance.clearFilter();
      this.griglia.griglia.instance.refresh()
    }
    else this.griglia.griglia.instance.filter(ciccio)

    setTimeout(() => {

      this.calculateMinMaxDates()
    }, 200);


  }

  createQueryFilter() {
    let result = '';

    const moment = require('moment');
    let ttt = moment(this.dallaData).format("YYYY-MM-DDT00:00:00")
    let ttt1 = moment(this.allaData).format("YYYY-MM-DDT23:59:59")

    result = "?dadata=" + ttt
    result += "&adata=" + ttt1
    //result+="&idsederentri="+this.selectedIdSito
    result += "&idregrentri=" + this.selectedIdRedistro
    result += "&codiceFiscaleAzienda=" + this.userservice.InfoUtenteConnesso.codiceFiscale
    return result;
  }
  stampaClick(ev) {
    console.log(ev)
    //alert(this.createQueryFilter())
    let query = this.createQueryFilter();
    query += ""
    this.loader.show();

    this.appService.GetApi("ModellodiStampa/GetByGUID/bb33baa2-fe89-467d-885d-fdcd3a547bfa").then(
      (modello: IModelloStampa) => {
        this.appService.GetApi("RenEsportazioni/GetElencoMovimenti" + query).then((result: any) => {

          this.loader.hide();


          this.modelliStampaService.generaPDF(result, modello, 'preview');
        }).catch(e => {
          this.loader.hide();
        })

      }).catch(e => {
        this.loader.hide();
      })
  }
  creaNomeZip() {

    let result = this.userservice.InfoUtenteConnesso.codiceFiscale + "-";

    let r = this.primaryListData.find(x => x.id === this.selectedIdSito)
    if (r) {
      result += "Movimenti U.L.=" + r.descrizione
    }
    const moment = require('moment');
    let ttt = moment(this.dallaData).format("DD-MM-YYYY")
    let ttt1 = moment(this.allaData).format("DD-MM-YYYY")
    //result+="Movimenti U.L.="+this.selectedIdSito
    result += " dal=" + ttt
    // result+="Movimenti  dal="+ttt
    result += " al " + ttt1
    //result+="&idsederentri="+this.selectedIdSito
    result += " Registro " + this.selectedIdRedistro
    result += ".zip"
    return result;

  }
  downloadClick(ev) {
    let query = this.createQueryFilter();
    this.loader.show();
    let link = environment.BASE_API_URL.concat("RenEsportazioni/GetArchivioZip" + query)
    const options = {
      method: 'GET', // Metodo della richiesta (es. GET, POST, PUT, DELETE)
      headers: {
        'Content-Type': 'application/json', // Specifica il tipo di contenuto
        'Authorization': 'Bearer ' + this.userservice.DammiToken(), // Esempio di header di autenticazione           
      }
    };

    fetch(link, options).then(
      (res) => {
        this.loader.hide();
        res.blob().then(
          
          (blob: Blob) => {
            saveAs(blob, this.creaNomeZip());
          });
      }
    ).catch(x => {
      this.loader.hide();
    })


  }


  xmlToJson(xml: any): any {
    let obj: any = {};
    if (xml.nodeType === 1) { // Element node
      if (xml.attributes.length > 0) {
        obj['@attributes'] = {};
        for (let j = 0; j < xml.attributes.length; j++) {
          const attribute = xml.attributes.item(j);
          obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType === 3) { // Text node
      obj = xml.nodeValue;
    }

    // Process child nodes
    if (xml.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
        const item = xml.childNodes.item(i);
        const nodeName = item.nodeName;
        if (typeof obj[nodeName] === 'undefined') {
          obj[nodeName] = this.xmlToJson(item);
        } else {
          if (!Array.isArray(obj[nodeName])) {
            const old = obj[nodeName];
            obj[nodeName] = [old];
          }
          obj[nodeName].push(this.xmlToJson(item));
        }
      }
    }
    return obj;
  }
  dammiRiferimentiMovimento(elem) {
    let rif = {
      causale: '',
      dataOraRegistrazione: null,
      numeroRegistrazione: null
    }
    if (elem['mov:Riferimenti']) {
      rif.causale = (elem['mov:Riferimenti']) ? elem['mov:Riferimenti']['mov:CausaleOperazione'] : ''
      rif.dataOraRegistrazione = (elem['mov:Riferimenti']) ? elem['mov:Riferimenti']['mov:DataOraRegistrazione'] : null
      rif.numeroRegistrazione = (elem['mov:Riferimenti']) ? elem['mov:Riferimenti']['mov:NumeroRegistrazione']['mov:Progressivo'] : ''
    }
    return rif;

  }
  dammiRifiutoDaMovimento(elem) {
    return {
      CodiceEer: elem['CodiceEer'],
      Provenienza: elem['Provenienza'],
      Quantita: {
        UnitaMisura: elem['mov:Quantita']['mov:UnitaMisura']['#text'],
        Valore: elem['mov:Quantita']['mov:Valore']['#text']
      },
    }
  }
  optionalButtonB(ev) {
    //anteprimaAllegato
    //console.log("eeeeeeeeeeeeeeee ",ev)

    this.idRenClicked = ev.row.data.id;

    console.log(ev.name)
    console.log(ev.row.data)

    //Todo----------------------------------- SIMONE---------------------------------------------
    //
    if (ev.name === "downloadPacchetto") {
      //ev.row.data.documento

      this.appService.GetApi("RenEsportazioni/" + this.idRenClicked).then(
        (renEsportazione: any) => {
      
      var constdecodedString = atob(renEsportazione.documento);
      let blob = new Blob([constdecodedString], { type: 'text/plain;charset=utf-8' })

      let result = this.userservice.InfoUtenteConnesso.codiceFiscale + "-";

      let r = this.primaryListData.find(x => x.id === ev.row.data.idsitorentri)
      if (r) {
        result += "Movimenti U.L.=" + r.descrizione
      }
      const moment = require('moment');
      let ttt = moment(ev.row.data.datainizio).format("DD-MM-YYYY")
      let ttt1 = moment(ev.row.data.datafine).format("DD-MM-YYYY")
      result += " dal=" + ttt
      result += " al " + ttt1
      result += " Registro " + ev.row.data.idregistrorentri
      result += ".xml"
      saveAs(blob, result)
    });
    }

    if (ev.name === "dettagliMovimenti") {

      //const guid='ShowRentriElencoMovimentiComponent'+ Math.random().toString().replace("0.", ""); ;
      let guid = Math.random().toString().replace("0.", "")
      let title = 'Elenco Movimenti';
      let dataToSend = {
        idElenco: this.idRenClicked,
        api: 'RenEsportazioni/GetElencoMovimentiById/' + this.idRenClicked,
        guid: guid,

      }

      this.userComponentService.setNewPopUp(guid, 'ShowRentriElencoMovimentiComponent', null, '90vw', null, dataToSend, false, false, title)
      this.userComponentService.outputComponent.subscribe(async (currentOutput) => {
        if (currentOutput.guid == guid) {
          const element = document.querySelector('.altezza')
          if (element) {
            (element as HTMLElement).style.height = "" + this.altezza + 'px'; // Imposta l'altezza a 200px
          }
        }




      })
    }

    //Todo----------------------------------- SIMONE---------------------------------------------

    if (ev.name === "anteprimaAllegato") {
      let query = "/" + this.idRenClicked;
      this.loader.show();

      this.appService.GetApi("ModellodiStampa/GetByGUID/bb33baa2-fe89-467d-885d-fdcd3a547bfa").then(
        (modello: IModelloStampa) => {

          this.appService.GetApi("RenEsportazioni/GetElencoMovimentiById" + query).then((result: any) => {
            this.loader.hide();
            this.modelliStampaService.generaPDF(result, modello, 'preview');
          }).catch(e => {
            this.loader.hide();
          })

        }).catch(e => {
          this.loader.hide();
        })

    }


  }

  calculateMinMaxDates() {
    const visibleRows = this.griglia.griglia.instance.getVisibleRows();
    const dates = visibleRows.reduce(
      (acc, row) => {
        if (row.data.datainizio) acc.push(new Date(row.data.datainizio));
        if (row.data.datafine) acc.push(new Date(row.data.datafine));

        //if (row.data.datainizio) acc.push(row.data.datainizio);
        //if (row.data.datafine) acc.push(row.data.datafine);
        return acc;
      },
      [] as Date[]
    );

    if (dates.length > 0) {
      this.minDate = new Date(Math.min(...dates.map(d => d.getTime()))).toDateString();
      this.maxDate = new Date(Math.max(...dates.map(d => d.getTime()))).toDateString();
    } else {
      this.minDate = null;
      this.maxDate = null;
    }
    // this.dallaData=this.minDate;
    // this.allaData=this.maxDate;
  }


  AllEvent(e) {

    //e.data.documento
    if (e.name == 'onSelectionChanged' && e.rowType == "data") {
      //this.idRenClicked=e.data.id
      //alert("ID="+e.data.id)
      //return;
      let dettagli = [];
      var constdecodedString = atob(e.data.documento); // Decoded string  
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(constdecodedString, 'text/xml');
      this.jsonResult = this.xmlToJson(xmlDoc);
      console.log('jsonResul: ', this.jsonResult);
      return;
      var Blocchi = this.jsonResult['reg:Registro']['reg:Registrazioni']

      if (isArray(Blocchi)) {
        Blocchi.forEach(Blocco => {
          if (Blocco['reg:Movimento']) {
            var Movimenti = Blocco['reg:Movimento']
            if (isArray(Movimenti)) {
              Movimenti.forEach(element => {
                let sigleReg = {
                  //cusale:element['mov:Riferimenti']['mov:CausaleOperazione'],
                  causale: (element['mov:Riferimenti']) ? element['mov:Riferimenti']['mov:CausaleOperazione'] : '',

                  dataOraRegistrazione: element['mov:Riferimenti']['mov:DataOraRegistrazione'],
                  numeroRegistrazione: element['mov:Riferimenti']['mov:NumeroRegistrazione']['mov:Progressivo'],
                  Rifiuto: this.dammiRifiutoDaMovimento(element['mov:Rifiuto'])
                }
                dettagli.push(sigleReg)
                console.log("----------- Movimento ---------------")
                console.log(element['mov:Riferimenti']['mov:CausaleOperazione'])
                console.log(element['mov:Riferimenti']['mov:DataOraRegistrazione'])
                console.log(element['mov:Riferimenti']['mov:NumeroRegistrazione']['mov:Progressivo'])
                console.log("----------- ------  ---------------")
              })
            } else {
              var element = Movimenti;
              let sigleReg = {
                //cusale:element['mov:Riferimenti']['mov:CausaleOperazione'],
                causale: (element['mov:Riferimenti']) ? element['mov:Riferimenti']['mov:CausaleOperazione'] : '',
                dataOraRegistrazione: element['mov:Riferimenti']['mov:DataOraRegistrazione'],
                numeroRegistrazione: element['mov:Riferimenti']['mov:NumeroRegistrazione']['mov:Progressivo'],
                Rifiuto: this.dammiRifiutoDaMovimento(element['mov:Rifiuto'])
              }
              dettagli.push(sigleReg)
              console.log("----------- Movimento ---------------")
              console.log(element['mov:Riferimenti']['mov:CausaleOperazione'])
              console.log(element['mov:Riferimenti']['mov:DataOraRegistrazione'])
              console.log(element['mov:Riferimenti']['mov:NumeroRegistrazione']['mov:Progressivo'])
              console.log("----------- ------  ---------------")
            }
          } // movimenti
          if (Blocco['reg:AnnullamentoMovimento']) {
            var Movimenti = Blocco['reg:AnnullamentoMovimento']
            if (isArray(Movimenti)) {
              Movimenti.forEach(element => {
                console.log("----------- Movimento Di Annullamento ---------------")
                //console.log(element['mov:Riferimenti']['mov:CausaleOperazione'])
                console.log(element['mov:Riferimenti']['mov:DataOraRegistrazione'])
                console.log(element['mov:Riferimenti']['mov:NumeroRegistrazione']['mov:Progressivo'])
                console.log("----------- ------  ---------------")
              })
            } else {
              var element = Movimenti;
              let sigleReg = {
                causale: (element['mov:Riferimenti']) ? element['mov:Riferimenti']['mov:CausaleOperazione'] : '',
                dataOraRegistrazione: element['mov:Riferimenti']['mov:DataOraRegistrazione'],
                numeroRegistrazione: element['mov:Riferimenti']['mov:NumeroRegistrazione']['mov:Progressivo'],
                Rifiuto: this.dammiRifiutoDaMovimento(element['mov:Rifiuto'])
              }
              dettagli.push(sigleReg)
              console.log("----------- Movimento Di Annullamento ---------------")
              //console.log(element['mov:Riferimenti']['mov:CausaleOperazione'])
              console.log(element['mov:DataOraRegistrazione'])
              console.log(element['mov:NumeroRegistrazione']['mov:Progressivo'])
              console.log("----------- ------  ---------------")
            }
          }
        })
        console.log(Blocchi);
        console.log(dettagli);
      }
      //var Produttore=   movimento['reg:Produttore'];
      //var Rifiuto   =   movimento['reg:Rifiuto'];
      //var Trasportatore=movimento['reg:Trasportatore'];
    }
  }
  optionalBottoneToolbar(ev) {
    if (ev == 1) { //stampa
      this.stampaClick(null);
    }
    if (ev == 2) { //download
      this.downloadClick(null)
    }
  }
}
/*

let blob = new Blob(['Hello, world!'], { type: 'text/plain;charset=utf-8' })
saveAs(blob, 'hello world.txt')

*/